import React, {useEffect, useState} from 'react';
import Router from './Router.js';
import {
    Cookie,
    ShieldCheck,
    Settings,
    Check,
    Globe,
    LayoutDashboard
} from 'lucide-react';
import {HelmetProvider} from "react-helmet-async";

// --- 1. Helper: Google Analytics Initialization ---
const initGoogleAnalytics = () => {
    //if (window.gaInitialized) return;
    //console.log("%c[System] Google Analytics Script Injected & Started Tracking...", "color: #0d6efd; font-weight: bold;");
    // ใส่ Code GA ของคุณที่นี่...
    // script.src = ...
    //window.gaInitialized = true;
};

// --- 2. Component: Cookie Settings Modal (ใช้ Bootstrap 5 Modal) ---
const CookieSettingsModal = ({ isOpen, onClose, onSave, savedPreferences }) => {
    const [preferences, setPreferences] = useState({
        necessary: true,
        performance: false
    });

    // เมื่อเปิด Modal ให้โหลดค่าล่าสุดที่บันทึกไว้มาแสดง
    useEffect(() => {
        if (isOpen && savedPreferences) {
            setPreferences(savedPreferences);
        }
    }, [isOpen, savedPreferences]);

    if (!isOpen) return null;

    return (
        <>
            {/* Backdrop (ฉากหลังสีดำจางๆ) */}
            <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>

            {/* Modal Dialog */}
            <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ zIndex: 1055 }}>
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content shadow-lg border-0 rounded-4">

                        {/* Header */}
                        <div className="modal-header bg-light border-bottom-0 py-3">
                            <h5 className="modal-title d-flex align-items-center gap-2 fw-bold text-dark">
                                <Settings size={20} className="text-primary" />
                                การตั้งค่าคุกกี้
                            </h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                        </div>

                        {/* Body */}
                        <div className="modal-body p-4">
                            <p className="text-muted small mb-2">
                                ท่านสามารถเลือกปรับแต่งการใช้งานคุกกี้ได้ตามหัวข้อด้านล่าง
                                คุกกี้ที่จำเป็นจะทำงานเสมอเพื่อให้เว็บไซต์ใช้งานได้ปกติ
                            </p>

                            {/* List Group สำหรับรายการตั้งค่า */}
                            <ul className="list-group list-group-flush">

                                {/* 1. Necessary (Disabled) */}
                                <li className="list-group-item d-flex justify-content-between align-items-start py-3 px-0 border-bottom">
                                    <div className="me-auto pe-3">
                                        <div className="fw-bold text-dark">คุกกี้ที่มีความจำเป็น (Strictly Necessary Cookies)</div>
                                        <div className="text-muted small mt-1">คุกกี้ประเภทนี้มีความจำเป็นต่อการให้บริการเว็บไซต์ เพื่อให้ท่านสามารถเข้าใช้งานในส่วนต่าง ๆ ของเว็บไซต์ได้ รวมถึงช่วยจดจำข้อมูลที่ท่านเคยให้ไว้ผ่านเว็บไซต์ การปิดการใช้งานคุกกี้ประเภทนี้จะส่งผลให้ท่านไม่สามารถใช้บริการในสาระสำคัญของ ศชวซ. ซึ่งจำเป็นต้องเรียกใช้คุกกี้ได้</div>
                                    </div>
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            checked={true}
                                            disabled
                                            style={{ transform: 'scale(1.3)', cursor: 'not-allowed' }}
                                        />
                                    </div>
                                </li>

                                {/* 2. Performance */}
                                <li className="list-group-item d-flex justify-content-between align-items-start py-3 px-0 border-bottom">
                                    <div className="me-auto pe-3">
                                        <div className="fw-bold text-dark">คุกกี้เพื่อการวิเคราะห์และประเมินผลการใช้งาน (Performance Cookies)</div>
                                        <div className="text-muted small mt-1">คุกกี้ประเภทนี้ช่วยให้ ทราบถึงการปฏิสัมพันธ์ของผู้ใช้งานในการใช้บริการเว็บไซต์ของ ศชวซ. รวมถึงหน้าเพจหรือพื้นที่ใดของเว็บไซต์ที่ได้รับความนิยม ตลอดจนการวิเคราะห์ข้อมูลด้านอื่น ๆ  ยังใช้ข้อมูลนี้เพื่อการปรับปรุงการทำงานของเว็บไซต์ และเพื่อเข้าใจพฤติกรรมของผู้ใช้งานมากขึ้น ถึงแม้ว่า ข้อมูลที่คุกกี้นี้เก็บรวบรวมจะเป็นข้อมูลที่ไม่สามารถระบุตัวตนได้ และนำมาใช้วิเคราะห์ทางสถิติเท่านั้น การปิดการใช้งานคุกกี้ประเภทนี้จะส่งผลให้ ไม่สามารถทราบปริมาณผู้เข้าเยี่ยมชมเว็บไซต์ และไม่สามารถประเมินคุณภาพการให้บริการได้</div>
                                    </div>
                                    <div className="form-check form-switch">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            style={{ transform: 'scale(1.3)', cursor: 'pointer' }}
                                            checked={preferences.performance}
                                            onChange={() => setPreferences(prev => ({...prev, performance: !prev.performance}))}
                                        />
                                    </div>
                                </li>
                            </ul>
                        </div>

                        {/* Footer */}
                        <div className="modal-footer bg-light border-top-0 py-3">
                            <button type="button" className="btn btn-outline-secondary rounded-pill px-4" onClick={onClose}>
                                ยกเลิก
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary rounded-pill px-4"
                                onClick={() => onSave(preferences)}
                            >
                                บันทึกการตั้งค่า
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

// --- 3. Component: Banner ด้านล่าง (ใช้ Bootstrap Fixed Bottom) ---
const CookieConsentBanner = ({ onAcceptAll, onOpenSettings }) => {
    return (
        <div className="fixed-bottom bg-white border-top shadow-lg p-3 p-md-4 fade show" style={{ zIndex: 1040 }}>
            <div className="container-fluid container-xl">
                <div className="row align-items-center g-3">

                    {/* Icon & Text */}
                    <div className="col-12 col-md-8 d-flex gap-3">
                        <div className="d-none d-md-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary rounded-circle p-3" style={{ width: 60, height: 60 }}>
                            <ShieldCheck size={30} />
                        </div>
                        <div>
                            <h5 className="fw-bold mb-1 d-flex align-items-center gap-2 text-dark">
                                <Cookie className="text-warning" size={20} />
                                การตั้งค่าคุกกี้ (Cookies)
                            </h5>
                            <p className="text-muted small mb-0 lh-base">
                                เว็บไซต์ของเราใช้คุกกี้เพื่อเพิ่มประสิทธิภาพ และประสบการณ์ที่ดีในการใช้เว็บไซต์ของคุณ อ่านรายละเอียดเพิ่มเติมได้ที่ <a href="https://ncsa.or.th/policy/privacynotice" target="_blank" className="text-decoration-underline link-primary">นโยบายความเป็นส่วนตัว</a> และ <a href="https://ncsa.or.th/policy/cookieconsent" target="_blank" className="text-decoration-underline link-primary">นโยบายคุกกี้</a> ท่านสามารถเลือก "ตั้งค่าคุกกี้" ด้วยตนเอง หรือกด "ยอมรับทั้งหมด"
                            </p>
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="col-12 col-md-4 d-flex justify-content-end gap-2">
                        <button
                            onClick={onOpenSettings}
                            className="btn btn-outline-secondary rounded-pill px-3 flex-fill flex-md-grow-0"
                        >
                            ตั้งค่าคุกกี้
                        </button>
                        <button
                            onClick={onAcceptAll}
                            className="btn btn-primary rounded-pill px-4 flex-fill flex-md-grow-0 d-flex align-items-center justify-content-center gap-2"
                        >
                            <Check size={18} />
                            ยอมรับทั้งหมด
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// --- 4. NEW: Reopen Button (ปุ่มลอยสำหรับเรียกเมนูตั้งค่ากลับมา) ---
const CookieReopenButton = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            style={{"position":"fixed","bottom":"24px","left":"24px","zIndex":"9990","backgroundColor":"white","color":"rgb(55, 65, 81)","border":"1px solid rgb(229, 231, 235)","borderRadius":"50px","padding":"10px 20px","display":"flex","alignItems":"center","gap":"8px","boxShadow":"rgba(0, 0, 0, 0.1) 0px 4px 12px","cursor":"pointer","fontWeight":"500","fontSize":"14px","fontFamily":"Sarabun, Prompt, sans-serif","transition":"transform 0.2s","transform":"scale(1)"}}
            title="การตั้งค่าคุกกี้"
        >
            <Cookie size={18} className="text-warning" />
            <span className="d-none d-sm-inline text-muted fw-medium">ตั้งค่าคุกกี้</span>
        </button>
    );
};

// --- 5. Main App (ตัวอย่างการนำไปใช้) ---
export default function App() {
    let urlSegment1 = window.location.pathname;
    const [showBanner, setShowBanner] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [gaStatus, setGaStatus] = useState('Waiting...');
    // เก็บค่า Settings ปัจจุบันไว้ใน State เพื่อส่งให้ Modal แสดงผล
    const [currentPreferences, setCurrentPreferences] = useState(null);

    // Inject Bootstrap CDN สำหรับการแสดงผลใน Preview นี้เท่านั้น
    // (ในโปรเจกต์จริง คุณไม่ต้องใส่ useEffect นี้ หากคุณมี Bootstrap อยู่แล้วใน index.html)
    useEffect(() => {

        // Check local storage
        const savedConsent = localStorage.getItem('cookie_consent_htcr');
        if (savedConsent) {
            const pref = JSON.parse(savedConsent);
            setCurrentPreferences(pref); // เก็บค่าลง State

            if (pref.analytics) {
                initGoogleAnalytics();
                setGaStatus('Active (Loaded from Storage)');
            } else {
                setGaStatus('Inactive');
            }
        } else {
            setShowBanner(true);
        }
    }, []);

    const handleAcceptAll = () => {
        const allPreferences = {
            necessary: true,
            performance: true
        };
        localStorage.setItem('cookie_consent_htcr', JSON.stringify(allPreferences));
        setCurrentPreferences(allPreferences); // อัปเดต State
        initGoogleAnalytics();
        setGaStatus('Active (Accepted All)');
        setShowBanner(false);
    };

    const handleSaveSettings = (preferences) => {
        localStorage.setItem('cookie_consent_htcr', JSON.stringify(preferences));
        setCurrentPreferences(preferences); // อัปเดต State
        if (preferences.analytics) {
            initGoogleAnalytics();
            setGaStatus('Active (Enabled Analytics)');
        } else {
            setGaStatus('Inactive (Disabled Analytics)');
        }
        setShowSettings(false);
        setShowBanner(false);
    };

    const handleReset = () => {
        localStorage.removeItem('cookie_consent_htcr');
        window.location.reload();
    };

    return (
        <>
            {
                urlSegment1 !== '/' && urlSegment1 !== '/en' ?
                    <>
                        <div className="preload">
                            <span className="loader"></span>
                        </div>
                        <div className="page">
                            <Router />
                        </div>
                    </> : <Router />
            }

            {/* --- ส่วน Cookie Consent --- */}

            {/* ถ้ายังไม่เคยตั้งค่า ให้โชว์ Banner */}
            {showBanner && urlSegment1 !== '/' && urlSegment1 !== '/en' && (
                <CookieConsentBanner
                    onAcceptAll={handleAcceptAll}
                    onOpenSettings={() => setShowSettings(true)}
                />
            )}

            {/* ถ้า Banner ไม่โชว์ (คือตั้งค่าไปแล้ว) ให้โชว์ปุ่ม Reopen ที่มุมซ้ายล่าง */}
            {!showBanner && urlSegment1 !== '/' && urlSegment1 !== '/en' && (
                <CookieReopenButton onClick={() => setShowSettings(true)} />
            )}

            {/* หน้าต่าง Modal ตั้งค่า (ส่งค่า currentPreferences เข้าไปเพื่อให้จำค่าเดิม) */}
            <CookieSettingsModal
                isOpen={showSettings}
                onClose={() => setShowSettings(false)}
                onSave={handleSaveSettings}
                savedPreferences={currentPreferences}
            />
        </>
    )
}